import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const countryService = {
  async getCountries(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/country", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveCountries() {
    try {
      const response = await apiClient.get("/country/active");
      const payload = response?.data || {};
      const data = extractData(payload);
      return toArray(data);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getCountryById(id) {
    if (!id) throw new Error("Country ID is required");

    try {
      const response = await apiClient.get(`/country/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createCountry(countryData) {
    try {
      const response = await apiClient.post("/country", countryData);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateCountry(id, countryData) {
    if (!id) throw new Error("Country ID is required");

    try {
      const response = await apiClient.patch(`/country/${id}`, countryData);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteCountry(id) {
    if (!id) throw new Error("Country ID is required");

    try {
      const response = await apiClient.delete(`/country/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default countryService;
